/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {updateUnitAppData} from '../api'

export const useMutationUpdateUnitAppData = createReactQueryMutationHook('updateUnitAppData', updateUnitAppData)
